import { merge } from 'lodash';
import localConfig from '../../public/config.js';

export default class Config {
  static defaults = {
    services: {
      portal: {
        available: true,
        superuser: true,
      },
      maps: {
        available: false,
        superuser: true,
      },
      geocontrib: {
        available: false,
        superuser: true,
      },
      stats: {
        available: false,
        superuser: true,
      },
      geoserver: {
        available: false,
        superuser: true,
      },
      geonetwork: {
        available: false,
        superuser: true,
      },
    },
    components: {
      QualityLabel: 'dataset-detail-top-anchor',
    },
    itemsPerPage: {
      datasets: 20,
      datasetPermissions: 20,
      jurisdictions: 50,
      organisations: 20,
      organisationContacts: 20,
      organisationMembers: 20,
      tasks: 20,
      users: 20,
      usergroups: 20,
      usergroupContacts: 20,
      usergroupParents: 20,
      usergroupChildren: 20,
      usergroupMembers: 20,
    },
    forms: {
      user: {
        hiddenFields: [],
        requiredFields: [
          'last_name',
          'first_name',
          'email'
        ]
      },
      organisation: {
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'organisation_type'
        ]
      },
      group: {
        hiddenFields: [],
        requiredFields: [
          'name'
        ]
      },
      sphere: {
        hiddenFields: [],
        requiredFields: [
          'name'
        ]
      },
      contact: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'email'
        ]
      },
      dataset: {
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'description',
          'keywords',
          'topics',
          'kinds',
          'usergroup',
          'publication_date',
          'lastUpdateDate',
          'update_frequency',
          'record_type'
        ],
        extraFields: []
      },
      resource: {
        datastore: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        'file-upload': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
            'column_x',
            'column_y',
            'crs'
          ]
        },
        ftp: {
          superuserOnly: true,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        href: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        'file-download': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        geoserver: {
          superuserOnly: false,
          hiddenFields: [
          ],
          requiredFields: [
            'display_name',
          ]
        }
      },
      indexer: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'url',
          'command',
          'scheduler',
        ]
      }
    },
    resourceTypes: [
      'datastore',
      'file-upload',
      'ftp',
      'href',
      'file-download',
      'geoserver'
    ],
    annexTypes: [
      'file-upload',
      'ftp',
      'href',
      'file-download',
    ],
    wms: {
      staticBaseUrl:'https://rec.onegeosuite.fr/maps'
    },
    features: {
      aiMetadataGeneration: {
        available: false
      }
    }

  }

  constructor() {
    Object.assign(this, merge(Config.defaults, localConfig || {}));
  }

}